import React from 'react';
import PropTypes from 'prop-types';

import { formatDate } from 'helpers/formatters/date_time_formats';

import ManagedInput from 'components/form/managed_input';
import RelativeInputs from './relative_inputs';
import { Button } from 'components/ui/button';
import { faX } from '@fortawesome/pro-solid-svg-icons';

export default function RelativeDateInput({ children, dateFields, dateValues, value, onCancel, onChange }) {
  const getFormattedDate = (name) => {
    if (dateValues[name] && dateValues[name].date) {
      return `(${formatDate(dateValues[name].date)})`;
    }
  };

  const getRelativeDateName = (value) => {
    if (typeof value !== 'number') {
      return value;
    } else {
      for (const name in dateValues) {
        if (dateValues[name].id === value) {
          return name;
        }
      }
      return null;
    }
  };

  return (
    <div>
      <div className="text-end">
        <Button aria-label="cancel" icon={faX} size="sm" variant="ghost" onClick={onCancel} />
      </div>

      {!value.static && <RelativeInputs value={value} onChange={onChange} />}

      <ManagedInput
        aria-label="relative-date-select"
        className="form-control my-2"
        includeBlank="Select Critical Date"
        name="relativeDateId"
        type="select"
        value={value.static ? null : getRelativeDateName(value.relativeDateId)}
        onValueChange={newValue => onChange({
          relativeDateId: dateValues[newValue]?.id || newValue,
          date: null,
          static: false,
          operator: value.operator || 'before',
          units: value.units || 'day'
        })}
      >
        {Object.keys(dateFields).sort((name1, name2) => {
          const getDate = name => (dateValues[name] && dateValues[name].date) || 'z';
          return getDate(name1).localeCompare(getDate(name2));
        }).map(name => (
          <option key={name} value={name}>
            {[dateFields[name].label, getFormattedDate(name)].join(' ')}
          </option>
        ))}
      </ManagedInput>

      {children}
    </div>
  );
}

RelativeDateInput.propTypes = {
  children: PropTypes.node,
  dateFields: PropTypes.objectOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
  })).isRequired,
  dateValues: PropTypes.objectOf(PropTypes.shape({
    date: PropTypes.string
  })).isRequired,
  value: PropTypes.shape({
    modifier: PropTypes.number,
    operator: PropTypes.string,
    relativeDateId: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    static: PropTypes.bool,
    units: PropTypes.string,
  }),
  onCancel: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};
